export default "__VITE_ASSET__wsIII2hU__"